import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const TitleWrapper = styled.h3`
    writing-mode: vertical-rl;
    text-orientation: mixed;
    transform: rotate(180deg);
    float: left;
    margin-top: 60px;
    font: 28px Open Sans, Helvetica, sans-serif;    
    font-weight: 400;
    color: lightgray;
    position: fixed;
    top: 5%;
    left: 1%;
`

const CompanyPageTitle = ({ label }) => {
    return (
        <TitleWrapper>
            { label }
        </TitleWrapper>
    )
}

CompanyPageTitle.propTypes = {
    /** Label to be displayed as the title */
    label: PropTypes.string.isRequired
}

CompanyPageTitle.defaultProps = {
    label: 'Placeholder title'
}

export default CompanyPageTitle;



// WEBPACK FOOTER //
// ./src/js/containers/CompanyContainer/CompanyPageTitle.jsx